/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_SearchInputs */

const cs_pm_search = /** @type {(inputs: Pm_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat v názvu, adrese, ID…`)
};

const en_pm_search = /** @type {(inputs: Pm_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search title, address, ID…`)
};

/**
* | output |
* | --- |
* | "Search title, address, ID…" |
*
* @param {Pm_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_search = /** @type {((inputs?: Pm_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_search(inputs)
	return cs_pm_search(inputs)
});